// In dev/build, /images is served from public/images. In production, set
// REACT_APP_IMAGES_BASE_URL to an S3/CloudFront origin instead of committing
// the photo library to the repo.
export const IMAGES_BASE_URL = process.env.REACT_APP_IMAGES_BASE_URL || "";
